import './index.scss';
import React from 'react';
import ReactDOM from 'react-dom';
import { configure } from 'mobx';
import registerServiceWorker from './sw';
import App from '@shared/App';
import './Web.config';
registerServiceWorker();
configure({
  enforceActions: 'observed'
});

var render = Component => {
  ReactDOM.render( /*#__PURE__*/React.createElement(Component, null), document.getElementById('app'));
};

render(App);